<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("SUPPLY_RULES.EDIT_SUPPLY_RULE") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <supply-rule-form
              :loading="loading"
              :supplyRuleData="supplyRule"
              :formErrors="formErrors"
              @supplyRuleSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultWarehouse from "./defaultSupplyRule";
import SupplyRuleForm from "./partials/SupplyRuleForm";

export default {
  layout: "DashboardLayout",

  components: { SupplyRuleForm },

  mixins: [alertLeave],

  data() {
    return {
      supplyRule: cloneDeep(defaultWarehouse),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("supplyRules/get", {
          id,
          hasFallback: true,
        });
        this.supplyRule = this.$store.getters["supplyRules/supplyRule"];
        this.supplyRule = {
          ...this.supplyRule,
          warehouse: this.supplyRule?.warehouse?.id
            ? this.supplyRule?.warehouse
            : {
                type: "warehouses",
                id: null,
              },
          supplier: this.supplyRule?.supplier?.id
            ? this.supplyRule?.supplier
            : {
                type: "suppliers",
                id: null,
              },
        };
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Supply Rules" });
    },

    viewSupplyRule() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Supply Rule",
        params: { id: this.supplyRule.id },
      });
    },

    async handleSubmit(supplyRule) {
      this.loading = true;
      const supplyRuleData = cloneDeep(supplyRule);
      try {
        await this.$store.dispatch("supplyRules/update", supplyRuleData);
        this.$notify({
          type: "success",
          message: this.$t("SUPPLY_RULES.SUPPLY_RULE_UPDATED"),
        });
        this.viewSupplyRule();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
